module.exports = {
  phoneNumberSanitizer: str => `${str}`.replace(/[\D\s]/g, ''),
};



// WEBPACK FOOTER //
// ./src/helpers/Sanitizers.js